module.exports = __webpack_public_path__ + "media/images/landing/client_GoPro-4ac033431167533899148ed026ef7ce9.png";